module.exports = __webpack_public_path__ + "static/media/fairLaunch.70ef8157.png";